export const REPORT_FIELD_VALUE_DESCRIPTION = "A short explanation showing how the value was determined, with references to the source document where possible.";
export const REPORT_FIELD_JUSTIFICATION_DESCRIPTION = "A justification showing how the value was determined, with references to the source document insights where possible";
/**
 * Represents the status of a property report generation process.
 */
export var PropertyReportStatus;
(function (PropertyReportStatus) {
    PropertyReportStatus["PENDING_DOCUMENTS"] = "pending_documents";
    PropertyReportStatus["READY_FOR_GENERATION"] = "ready_for_generation";
    PropertyReportStatus["GENERATING"] = "generating";
    PropertyReportStatus["COMPLETED"] = "completed";
    PropertyReportStatus["FAILED"] = "failed";
})(PropertyReportStatus || (PropertyReportStatus = {}));
/**
 * Array of all possible property report field keys
 * Used when generating a complete property report
 */
export const ALL_PROPERTY_REPORT_FIELD_KEYS = [
    // Property Overview
    "propertyOverview.buildingName",
    "propertyOverview.ageOfBuilding",
    "propertyOverview.constructionType",
    "propertyOverview.numberOfUnits",
    "propertyOverview.numberOfFloors",
    // Financial Information
    "financialInformation.monthlyStrataFees",
    "financialInformation.contingencyReserveFund.currentBalance",
    "financialInformation.contingencyReserveFund.recentExpenditures",
    "financialInformation.contingencyReserveFund.anticipatedFutureSpending",
    "financialInformation.contingencyReserveFund.analysis",
    "financialInformation.specialLevies",
    // Building Condition
    "buildingCondition.buildingComponents",
    // Rules and Restrictions
    "rulesAndRestrictions.petPolicy",
    "rulesAndRestrictions.rentalRestrictions",
    "rulesAndRestrictions.smokingRestrictions",
    "rulesAndRestrictions.otherRestrictions",
    // Amenities
    "amenities.availableFacilities",
    "amenities.parkingAndStorage",
    "amenities.bicycleStorage",
    // Insurance Summary
    "insuranceSummary.provider",
    "insuranceSummary.ownerInsuranceRequired",
    "insuranceSummary.deductible",
    "insuranceSummary.coverageSummary",
    // Community and Management
    "communityAndManagement.strataManagementCompanyInfo.name",
    "communityAndManagement.strataManagementCompanyInfo.contact",
    "communityAndManagement.strataManagementCompanyInfo.notes",
    "communityAndManagement.councilInfo.numberOfMembers",
    "communityAndManagement.councilInfo.meetingFrequency",
    "communityAndManagement.councilInfo.currentInitiatives",
    // Local Area Insights
    "localAreaInsights.neighbourhoodHighlights",
    "localAreaInsights.recentComparableSales",
    // Additional Notes
    "additionalNotes.potentialBuyerConcerns",
    "additionalNotes.uniqueSellingPoints",
];
//# sourceMappingURL=propertyReportTypes.js.map